import { useHistory } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import * as PageLayout from 'features/Bento/components/PageLayout';

type LayoutProps = {
  allowBack?: boolean;
};

const Layout: FCWithChildren<LayoutProps> = ({ allowBack, children }) => {
  const history = useHistory();

  return (
    <PageLayout.Grid
      gridGap="0"
      height="100%"
      templateAreas={`
        "actions actions actions"
        ". body ."
      `}
      templateColumns="calc(33.3vw - 260px) 1fr 1fr"
      templateRows="80px auto"
      width="100%"
    >
      {allowBack ? (
        <Box padding="space-24">
          <PageLayout.Actions onBack={() => history.goBack()} />
        </Box>
      ) : null}

      <PageLayout.Body gridArea="body" padding="space-4">
        <Flex justifyContent="center">
          <Box maxWidth="460px">{children}</Box>
        </Flex>
      </PageLayout.Body>
    </PageLayout.Grid>
  );
};

export default Layout;
